export class GalleryHieroglyphData {
    public readonly contentIndeces: number[];
    public readonly colourIndex: number;
    public readonly weatherIndex: number;

    constructor(pContentIndeces: number[], pColourIndex: number, pWeatherIndex: number) {
        this.contentIndeces = pContentIndeces;
        this.colourIndex = pColourIndex;
        this.weatherIndex = pWeatherIndex;
    }
}
